var map = {
	"./afternoon-active.svg": 9426,
	"./afternoon.svg": 827,
	"./all-active.svg": 8601,
	"./all.svg": 9818,
	"./evening-active.svg": 466,
	"./evening.svg": 3547,
	"./morning-active.svg": 6241,
	"./morning.svg": 9679,
	"./night-active.svg": 4943,
	"./night.svg": 7697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4189;